import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { withAds } from '../../context/withAds';
import AdContextType from '../../context/type';
import { getBrowserState } from '../../helpers';
import '../../index.scss';

// A class name that should be blocked by most major ad blockers. Used to save space when an ad blocker is active.
// This particular class name is arbitrarily chosen from https://easylist-downloads.adblockplus.org/easylist.txt
const adBlockerClassName = 'AdBox';

const matchPlacementNameToPublisherdesk = (
  placementName,
  browserState = 'mobile'
) => {
  switch (placementName) {
    case 'panorama_extra':
    case 'panorama_extra_2':
      return 'dsk-banner-ad-b';
    case 'panorama_top':
      return 'dsk-banner-ad-a';
    case 'skyscraper_1':
      return browserState === 'desktop' ? 'dsk-box-ad-a' : '';
    case 'skyscraper_2':
      return browserState === 'desktop' ? 'dsk-box-ad-b' : '';
    case 'skyscraper_3':
      return browserState === 'desktop' ? 'dsk-box-ad-c' : '';
    case 'dubbelpanorama1':
      return 'mob-banner-ad-a';
    case 'dubbelpanorama2':
      return 'mob-box-ad-a';
    case 'dubbelpanorama3':
      return 'mob-box-ad-b';
    case 'panorama_footer':
    case 'panorama_target':
      return '';
    default:
      return placementName;
  }
};

const PublisherdeskContainer = props => {
  const [placementID, setPlacementID] = useState(
    matchPlacementNameToPublisherdesk(props.placement)
  );

  useEffect(() => {
    if (!IS_BROWSER) {
      return;
    }
    setPlacementID(
      matchPlacementNameToPublisherdesk(
        props.placement,
        getBrowserState().siteMode
      )
    );
  }, []);

  return <div id={placementID} className={adBlockerClassName} />;
};

const { string } = PropTypes;

PublisherdeskContainer.propTypes = {
  placement: string.isRequired,
};

const PublisherdeskContainerWithAds = withAds(props =>
  props.adContext && props.adServiceContext ? (
    <PublisherdeskContainer {...props} />
  ) : null
);

PublisherdeskContainerWithAds.propTypes = {
  adContext: AdContextType,
};

PublisherdeskContainerWithAds.defaultProps = {
  adContext: undefined,
  adServiceContext: undefined,
};

export default PublisherdeskContainerWithAds;
